'use es6';

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import notifications from 'ReduxMessenger/reducers/Notifications';
import auth from './auth';
import autocomplete from './autocomplete';
import directoryData from './directoryData';
import goodDetails from './goodDetails';
import managePurchases from './managePurchases';
import providers from './providers';
import reviewInputInfo from './reviewInputInfo';
import trialState from './trialState';
export default combineReducers({
  auth: auth,
  autocomplete: autocomplete,
  directoryData: directoryData,
  goodDetails: goodDetails,
  managePurchases: managePurchases,
  providers: providers,
  reviewInputInfo: reviewInputInfo,
  routing: routerReducer,
  notifications: notifications,
  trialState: trialState
});